module.exports = __webpack_public_path__ + "static/img/01-banner.12c80f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-cgM/01-banner.jpg
// module id = 0sd8
// module chunks = 1